// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 로그인 화면 스타일 */
.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f0f2f5;
}

.login-box {
  background: white;
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 400px;
}

.login-title {
  text-align: center;
  font-size: 1.5rem;
  color: #1a1a2e;
  margin-bottom: 32px;
  font-weight: 700;
}

/* 임시 개발용 힌트 박스 - 나중에 삭제 예정 */
.dev-hint {
  background-color: #fff8e1;
  border: 1px dashed #f0a500;
  border-radius: 4px;
  padding: 8px 12px;
  margin-bottom: 16px;
  font-size: 0.85rem;
  color: #7a5300;
  text-align: center;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-group label {
  font-size: 0.9rem;
  font-weight: 600;
  color: #333;
}

.form-group input {
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
  transition: border-color 0.2s;
}

.form-group input:focus {
  outline: none;
  border-color: #4a90e2;
}

.error-message {
  color: #e74c3c;
  font-size: 0.875rem;
  text-align: center;
  margin: 0;
}

.login-button {
  padding: 12px;
  background-color: #1a1a2e;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
  margin-top: 8px;
}

.login-button:hover:not(:disabled) {
  background-color: #16213e;
}

.login-button:disabled {
  background-color: #999;
  cursor: not-allowed;
}

/* ── 회원가입 링크 ── */
.lp-signup-row {
  margin-top: 16px;
  text-align: center;
  font-size: 0.875rem;
  color: #666;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.lp-signup-link {
  background: none;
  border: none;
  color: #4a90e2;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 600;
  padding: 0;
  text-decoration: underline;
}
.lp-signup-link:hover { color: #2d6abf; }

/* ── 모달 오버레이 ── */
.lp-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.lp-modal {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.18);
  width: 400px;
  max-width: 95vw;
  overflow: hidden;
}

.lp-modal-hd {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  background: #1a1a2e;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
}

.lp-modal-close {
  background: none;
  border: none;
  color: #fff;
  font-size: 18px;
  cursor: pointer;
  padding: 0;
  line-height: 1;
}
.lp-modal-close:hover { color: #ccc; }

.lp-modal-bd {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.lp-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.lp-field label {
  font-size: 13px;
  font-weight: 600;
  color: #333;
}

.lp-field input {
  padding: 8px 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}
.lp-field input:focus {
  outline: none;
  border-color: #4a90e2;
}

.lp-error {
  color: #e74c3c;
  font-size: 13px;
  margin: 0;
  text-align: center;
}

.lp-done-msg {
  text-align: center;
  font-size: 14px;
  color: #333;
  line-height: 1.6;
  margin: 0 0 4px;
}

.lp-temp-notice {
  font-size: 13px;
  color: #e07000;
  background: #fff8ec;
  border: 1px solid #f0c080;
  border-radius: 4px;
  padding: 8px 12px;
  line-height: 1.5;
  margin: 0;
}

.lp-modal-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  margin-top: 4px;
}

.lp-btn-primary {
  padding: 8px 20px;
  background: #1a1a2e;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}
.lp-btn-primary:hover:not(:disabled) { background: #16213e; }
.lp-btn-primary:disabled { background: #999; cursor: not-allowed; }

.lp-btn-outline {
  padding: 8px 20px;
  background: #fff;
  color: #333;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
}
.lp-btn-outline:hover { background: #f5f5f5; }

/* ── 회원가입 팝업 확장 ── */
.lp-modal--signup {
  max-height: 90vh;
  overflow-y: auto;
}

.lp-modal--wide {
  width: 520px;
}

/* 동의 섹션 */
.lp-agree-section {
  border: 1px solid #e5e5e5;
  border-radius: 5px;
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  background: #fafafa;
}

.lp-agree-row {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
}

.lp-agree-row input[type="checkbox"] {
  flex-shrink: 0;
  width: 15px;
  height: 15px;
  cursor: pointer;
  accent-color: #1a1a2e;
}

.lp-agree-row label {
  flex: 1 1;
  font-size: 13px;
  font-weight: 400;
  color: #333;
  cursor: pointer;
}

.lp-agree-view {
  flex-shrink: 0;
  background: none;
  border: 1px solid #ccc;
  border-radius: 3px;
  font-size: 11px;
  color: #555;
  padding: 2px 6px;
  cursor: pointer;
  white-space: nowrap;
}
.lp-agree-view:hover { background: #f0f0f0; }

/* 동의 내용 텍스트 */
.lp-agree-content {
  background: #f8f8f8;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 12px;
  font-size: 13px;
  line-height: 1.6;
  white-space: pre-wrap;
  word-break: break-all;
  max-height: 400px;
  overflow-y: auto;
  margin: 0;
  font-family: inherit;
}
`, "",{"version":3,"sources":["webpack://./src/pages/LoginPage.css"],"names":[],"mappings":"AAAA,eAAe;AACf;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,yCAAyC;EACzC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,0BAA0B;AAC5B;AACA,wBAAwB,cAAc,EAAE;;AAExC,kBAAkB;AAClB;EACE,eAAe;EACf,QAAQ;EACR,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,uCAAuC;EACvC,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,UAAU;EACV,cAAc;AAChB;AACA,wBAAwB,WAAW,EAAE;;AAErC;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA,uCAAuC,mBAAmB,EAAE;AAC5D,2BAA2B,gBAAgB,EAAE,mBAAmB,EAAE;;AAElE;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;AACA,wBAAwB,mBAAmB,EAAE;;AAE7C,qBAAqB;AACrB;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA,UAAU;AACV;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA,uBAAuB,mBAAmB,EAAE;;AAE5C,cAAc;AACd;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,oBAAoB;AACtB","sourcesContent":["/* 로그인 화면 스타일 */\n.login-container {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #f0f2f5;\n}\n\n.login-box {\n  background: white;\n  padding: 40px;\n  border-radius: 8px;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);\n  width: 100%;\n  max-width: 400px;\n}\n\n.login-title {\n  text-align: center;\n  font-size: 1.5rem;\n  color: #1a1a2e;\n  margin-bottom: 32px;\n  font-weight: 700;\n}\n\n/* 임시 개발용 힌트 박스 - 나중에 삭제 예정 */\n.dev-hint {\n  background-color: #fff8e1;\n  border: 1px dashed #f0a500;\n  border-radius: 4px;\n  padding: 8px 12px;\n  margin-bottom: 16px;\n  font-size: 0.85rem;\n  color: #7a5300;\n  text-align: center;\n}\n\n.login-form {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.form-group label {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: #333;\n}\n\n.form-group input {\n  padding: 10px 12px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 1rem;\n  transition: border-color 0.2s;\n}\n\n.form-group input:focus {\n  outline: none;\n  border-color: #4a90e2;\n}\n\n.error-message {\n  color: #e74c3c;\n  font-size: 0.875rem;\n  text-align: center;\n  margin: 0;\n}\n\n.login-button {\n  padding: 12px;\n  background-color: #1a1a2e;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  margin-top: 8px;\n}\n\n.login-button:hover:not(:disabled) {\n  background-color: #16213e;\n}\n\n.login-button:disabled {\n  background-color: #999;\n  cursor: not-allowed;\n}\n\n/* ── 회원가입 링크 ── */\n.lp-signup-row {\n  margin-top: 16px;\n  text-align: center;\n  font-size: 0.875rem;\n  color: #666;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.lp-signup-link {\n  background: none;\n  border: none;\n  color: #4a90e2;\n  cursor: pointer;\n  font-size: 0.875rem;\n  font-weight: 600;\n  padding: 0;\n  text-decoration: underline;\n}\n.lp-signup-link:hover { color: #2d6abf; }\n\n/* ── 모달 오버레이 ── */\n.lp-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0,0,0,0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.lp-modal {\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 4px 24px rgba(0,0,0,0.18);\n  width: 400px;\n  max-width: 95vw;\n  overflow: hidden;\n}\n\n.lp-modal-hd {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 20px;\n  background: #1a1a2e;\n  color: #fff;\n  font-size: 15px;\n  font-weight: 600;\n}\n\n.lp-modal-close {\n  background: none;\n  border: none;\n  color: #fff;\n  font-size: 18px;\n  cursor: pointer;\n  padding: 0;\n  line-height: 1;\n}\n.lp-modal-close:hover { color: #ccc; }\n\n.lp-modal-bd {\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.lp-field {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.lp-field label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #333;\n}\n\n.lp-field input {\n  padding: 8px 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 14px;\n}\n.lp-field input:focus {\n  outline: none;\n  border-color: #4a90e2;\n}\n\n.lp-error {\n  color: #e74c3c;\n  font-size: 13px;\n  margin: 0;\n  text-align: center;\n}\n\n.lp-done-msg {\n  text-align: center;\n  font-size: 14px;\n  color: #333;\n  line-height: 1.6;\n  margin: 0 0 4px;\n}\n\n.lp-temp-notice {\n  font-size: 13px;\n  color: #e07000;\n  background: #fff8ec;\n  border: 1px solid #f0c080;\n  border-radius: 4px;\n  padding: 8px 12px;\n  line-height: 1.5;\n  margin: 0;\n}\n\n.lp-modal-actions {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n  margin-top: 4px;\n}\n\n.lp-btn-primary {\n  padding: 8px 20px;\n  background: #1a1a2e;\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n}\n.lp-btn-primary:hover:not(:disabled) { background: #16213e; }\n.lp-btn-primary:disabled { background: #999; cursor: not-allowed; }\n\n.lp-btn-outline {\n  padding: 8px 20px;\n  background: #fff;\n  color: #333;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 14px;\n  cursor: pointer;\n}\n.lp-btn-outline:hover { background: #f5f5f5; }\n\n/* ── 회원가입 팝업 확장 ── */\n.lp-modal--signup {\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.lp-modal--wide {\n  width: 520px;\n}\n\n/* 동의 섹션 */\n.lp-agree-section {\n  border: 1px solid #e5e5e5;\n  border-radius: 5px;\n  padding: 10px 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  background: #fafafa;\n}\n\n.lp-agree-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n}\n\n.lp-agree-row input[type=\"checkbox\"] {\n  flex-shrink: 0;\n  width: 15px;\n  height: 15px;\n  cursor: pointer;\n  accent-color: #1a1a2e;\n}\n\n.lp-agree-row label {\n  flex: 1;\n  font-size: 13px;\n  font-weight: 400;\n  color: #333;\n  cursor: pointer;\n}\n\n.lp-agree-view {\n  flex-shrink: 0;\n  background: none;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  font-size: 11px;\n  color: #555;\n  padding: 2px 6px;\n  cursor: pointer;\n  white-space: nowrap;\n}\n.lp-agree-view:hover { background: #f0f0f0; }\n\n/* 동의 내용 텍스트 */\n.lp-agree-content {\n  background: #f8f8f8;\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n  padding: 12px;\n  font-size: 13px;\n  line-height: 1.6;\n  white-space: pre-wrap;\n  word-break: break-all;\n  max-height: 400px;\n  overflow-y: auto;\n  margin: 0;\n  font-family: inherit;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
